import React from 'react';
import styled from 'styled-components';
import { Modal, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Text } from 'atoms';
// import { makeAllBillBack } from 'store/invoiceSlice';
import { final_submit } from 'store/salesmanSlice';
import { redirectToLogin } from 'api/authentication';

const MakeBillBackBtn = styled.div`
	height: 32px;
	margin-top: 1rem;
	border-radius: 4px;
	background-color: ${(props) => props.theme.colors.YellowOrange};
	color: ${(props) => props.theme.colors.OnyxS};
	line-height: 32px;
	text-align: center;
	font-size: 11.5px;
	cursor: pointer;
`;

const JusLogout = styled.div`
	height: 32px;
	margin-top: 1rem;
	border-radius: 4px;
	border: 1px solid #ffb056;
	color: ${(props) => props.theme.colors.OnyxS};
	line-height: 32px;
	text-align: center;
	font-size: 12px;
	cursor: pointer;
`;

export default function MakeAllBillBack({ visible, hide, isPending }) {
	const dispatch = useDispatch();
	const { me = {} } = useSelector((state) => state.user);
	const { invoiceDate } = useSelector((state) => state.app);

	function handleAllBillBack() {
		const showMessage = false;

		if (isPending) {
			message.error('Please select  Bill Back reason for pending invoices before you submit');
		} else {
			// dispatch(makeAllBillBack()).then(() => {
			dispatch(final_submit(me?.id, invoiceDate, showMessage)).then(() => {
				window.location = `${window.origin}/login`;

				// window.location.reload();
				hide();
			});
			// });
		}
	}

	const handleLogout = () => {
		redirectToLogin();
	};

	return (
		<Modal footer={null} visible={visible} onCancel={hide} width={385}>
			<Text textAlign="center" fontSize="12px">
				Still there are pending invoices !
			</Text>
			<Text textAlign="center" fontSize="12px" pt="1rem">
				Do you want to
			</Text>
			<JusLogout onClick={handleLogout}>Logout</JusLogout>
			<Text textAlign="center" fontSize="12px" pt="1rem">
				or
			</Text>

			<MakeBillBackBtn onClick={handleAllBillBack}>
				Mark invoices as Returned and Logout
			</MakeBillBackBtn>
		</Modal>
	);
}

MakeAllBillBack.propTypes = {
	visible: PropTypes.bool,
	hide: PropTypes.func.isRequired,
	isPending: PropTypes.bool,
};
